import { lazy } from 'react';
import { APIScope, LocationScope, LocationVarKey, } from '@swivl-mono/types';

import LocationSubpageOrgAdmin from "./Pages/Location.Subpage.Org.Admin";
import LocationSubpageInformation from "./Pages/Location.Subpage.Information";
import LocationSubpageSwivlFeature from "./Pages/Location.Subpage.Swivl-Features";
import LocationSubpageStorageFeatures from "./Pages/Location.Subpage.Storage-Features";
import LocationSubpageStorageTypes from "./Pages/Location.Subpage.Storage-Types";
import LocationSubpageHours from "./Pages/Location.Subpage.Hours";
import LocationSubpageImportantURLs from "./Pages/Location.Subpage.Important-URLs";
import LocationSubpageAdvancedSettings from "./Pages/Location.Subpage.Advanced-Settings";
import LocationSubpageSpot from "./Pages/Location.Subpage.Spot";
import { IS_NOT_EQUAL, RouterWorksheetData } from '../../Components/Worksheets/Types/Worksheet.Interface';


export const LocationWorksheetsData: { [key in LocationScope]: RouterWorksheetData[] } = {
  //    {to: `info`, label: 'Org Information', hideIf:IS_NOT_EQUAL(LocationVarKey.AgentAssistEnabled,"1"), element:<LocationSubpageInformation />},

  [LocationScope.ORG]: [
    { to: `admin`, label: 'Org Admin', element: <LocationSubpageOrgAdmin />, apiScope: APIScope.SUPER_ADMIN_ONLY },
    { to: `info`, label: 'Org Information', element: <LocationSubpageInformation /> },
    { to: `features`, label: 'Org Features', element: <LocationSubpageSwivlFeature /> },
    { to: `important-urls`, label: 'Important URLs', element: <LocationSubpageImportantURLs /> },
    { to: `storage-types`, label: 'Storage Types', element: <LocationSubpageStorageTypes /> },
    { to: `amenities`, label: 'Amenities', element: <LocationSubpageStorageFeatures /> },
    { to: `hours`, label: 'Hours', element: <LocationSubpageHours /> },
    //{ to: `spot`, label: 'spot.is', element: <LocationSubpageSpot /> },
    { to: `advanced-settings`, label: 'Advanced Settings', element: <LocationSubpageAdvancedSettings /> },
  ],
  [LocationScope.GROUP]: [
    { to: `admin`, label: 'Group Admin', element: <LocationSubpageOrgAdmin />, apiScope: APIScope.SUPER_ADMIN_ONLY },
    { to: `info`, label: 'Group Information', element: <LocationSubpageInformation /> },
    { to: `features`, label: 'Group Features', element: <LocationSubpageSwivlFeature /> },
    { to: `important-urls`, label: 'Important URLs', element: <LocationSubpageImportantURLs /> },
    { to: `storage-types`, label: 'Storage Types', element: <LocationSubpageStorageTypes /> },
    { to: `amenities`, label: 'Amenities', element: <LocationSubpageStorageFeatures /> },
    { to: `hours`, label: 'Hours', element: <LocationSubpageHours /> },
    // { to: `spot`, label: 'spot.is', element: <LocationSubpageSpot /> },
    { to: `advanced-settings`, label: 'Advanced Settings', element: <LocationSubpageAdvancedSettings /> },
  ],
  [LocationScope.LOCATION]: [
    { to: `admin`, label: 'Location Admin', element: <LocationSubpageOrgAdmin />, apiScope: APIScope.SUPER_ADMIN_ONLY },
    { to: `info`, label: 'Location Information', element: <LocationSubpageInformation /> },
    { to: `features`, label: 'Location Features', element: <LocationSubpageSwivlFeature /> },
    { to: `important-urls`, label: 'Important URLs', element: <LocationSubpageImportantURLs /> },
    { to: `storage-types`, label: 'Storage Types', element: <LocationSubpageStorageTypes /> },
    { to: `amenities`, label: 'Amenities', element: <LocationSubpageStorageFeatures /> },
    { to: `hours`, label: 'Hours', element: <LocationSubpageHours /> },
    // { to: `spot`, label: 'spot.is', element: <LocationSubpageSpot /> },
    { to: `advanced-settings`, label: 'Advanced Settings', element: <LocationSubpageAdvancedSettings /> },
  ]
}


